import {
  NotificationPlugin,
  ModalPlugin,
  I18nPlugin,
} from '@seedkit/vue/plugins';
import ApexchartsPlugin from './apexcharts-plugin';

export default {
  'notification': NotificationPlugin,
  'modal': ModalPlugin,
  'i18n': I18nPlugin,
  'apexcharts': ApexchartsPlugin,
};
